export const modalActionTypes = {
    SET_USER_ERROR_MODAL: 'SET_USER_ERROR_MODAL',
    SET_ADD_SAMPLE_ATTRIBUTES_MODAL: 'SET_ADD_SAMPLE_ATTRIBUTES_MODAL',
    SET_MODAL: 'SET_MODAL',
    SET_SUBMIT_MODAL: 'SET_SUBMIT_MODAL',
    SET_VIEW_SAMPLE_ATTRIBUTES_MODAL: 'SET_VIEW_SAMPLE_ATTRIBUTES_MODAL',
    SET_NEW_COHORT_DIMENSION: 'SET_NEW_COHORT_DIMENSION',
    SET_SAMPLE_BLOCK_CLICK_EVENT: 'SET_SAMPLE_BLOCK_CLICK_EVENT'
};
